// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__324Gb","label":"Labeled_label__2uRR1","divider":"Labeled_divider__2GCaZ"};